// export { request } from '@umijs/max';
import { TOKEN } from '@/common/const';
import type { RequestOptionsInit } from 'umi-request';
import stroge from './stroge';
import { message, notification } from 'antd';
import { goLogin } from './oauth2';


export const authHeaderInterceptor = (url: string, options: RequestOptionsInit) => {
    const token = stroge.get(TOKEN);
    const authHeader = token ? { Authorization: 'Bearer '+ token.access_token!, } : {};
    return {
        url: `${url}`,
        options: { ...options, interceptors: true, headers: authHeader },
    };
};

export const responseInterceptors = async (response: Response, options: RequestOptionsInit) => {
    // const data = await response.clone().json();
    // if (!data.success) {
    //    return new Error(data.errorMessage);
  
    // }
    return response;
};


const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};
/**
 * 异常处理程序
 */
export const errorHandler = (error: { response: Response }): Response => {
    const { response } = error;
    if (response && response.status) {
        if (response.status === 401) {
            stroge.remove(TOKEN);
            goLogin()
            // response.clone().json().then(data => {
            //     message.error(data.code  + ':'+  data.errorMessage ||   '登录失效，请重新登录', 2, goLogin);
            // })
            return response;
        }
        const errorText = codeMessage[response.status] || response.statusText;
        const { status, url } = response;

        message.error({
            content: errorText,
        });
    } else if (!response) {
        message.error({
            content: '您的网络发生异常，无法连接服务器',
        });
    }
    return response;
};
